import { useI18nContext } from "@i18n/i18n-react";
import type { Locales } from "@i18n/i18n-types";
import { loadLocaleAsync, loadNamespaceAsync } from "@i18n/i18n-util.async";
import { cn } from "@shadcn/lib/utils";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shadcn/ui/select";

const languages = [
	{ code: "en" as Locales, label: "English", flag: "🇬🇧" },
	{ code: "de" as Locales, label: "Deutsch", flag: "🇩🇪" },
];

type LanguageSelectorProps = {
	triggerClassName?: string;
};

export const LanguageSelector = (props: LanguageSelectorProps) => {
	const { triggerClassName } = props;
	const { locale } = useI18nContext();

	const handleLanguageChange = async (newLocale: Locales) => {
		console.log("Changing language to:", newLocale);
		localStorage.setItem("locale", newLocale);

		try {
			await loadLocaleAsync(newLocale);

			const currentPath = window.location.pathname;
			console.log("Current path:", currentPath);

			if (currentPath.includes("/consumer-app")) {
				await Promise.all([
					loadNamespaceAsync(newLocale, "consumer-app"),
					loadNamespaceAsync(newLocale, "auth"),
					loadNamespaceAsync(newLocale, "shared"),
				]);
			} else if (currentPath.includes("/dashboard")) {
				await Promise.all([
					loadNamespaceAsync(newLocale, "dashboard"),
					loadNamespaceAsync(newLocale, "auth"),
					loadNamespaceAsync(newLocale, "shared"),
				]);
			} else if (currentPath.includes("/embed")) {
				await Promise.all([loadNamespaceAsync(newLocale, "embed"), loadNamespaceAsync(newLocale, "shared")]);
			} else {
				// For new-ui and other apps
				await Promise.all([loadNamespaceAsync(newLocale, "auth"), loadNamespaceAsync(newLocale, "shared")]);
			}

			console.log("Language changed, reloading page...");
			window.location.reload();
		} catch (error) {
			console.error("Failed to load locale:", error);
		}
	};

	return (
		<Select value={locale} onValueChange={handleLanguageChange}>
			<SelectTrigger className={cn("w-[140px]", triggerClassName)}>
				<SelectValue />
			</SelectTrigger>
			<SelectContent>
				{languages.map((lang) => (
					<SelectItem key={lang.code} value={lang.code}>
						<span className="flex items-center gap-2">
							<span>{lang.flag}</span>
							<span>{lang.label}</span>
						</span>
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
